import { createTheme } from '@mui/material/styles'

const media = createTheme({})

const theme: any = {
  //thats done for using breakpoints
  ...media,
  typography: {
    fontFamily: 'CircularRegular'
  },
  palette: {
    primary: {
      main: '#4f9b44',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#F41211',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#F41211',
      contrastText: '#ffffff'
    },
    grey: {
      100: '#E5E5E5', // for lines
      200: '#F1F2F4', // for background
      300: '#80868E' // for text
    }
  },
  components: ({
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: 400
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h5: {
          fontFamily: 'CircularBold'
        },
        h4: {
          fontFamily: 'CircularBold'
        },
        h3: {
          fontFamily: 'CircularBold'
        },
        h2: {
          fontFamily: 'CircularBold'
        },
        h1: {
          fontFamily: 'CircularBold'
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: 400
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: 'none'
        },
        root: {
          minHeight: '40px',
          fontWeight: 400
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: '40px',
          fontWeight: 400,
          [media.breakpoints.up('sm')]: {
            minWidth: 'auto'
          }
        },
        textColorInherit: {
          opacity: '1'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#4f9b44'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          fontSize: '0.8rem',
          transform: 'translate(8px, 10px) scale(1)'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 400
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 0 0'
        }
      }
    },
    /**
     * Yksi nappityyli koko sovellukseen (koskee myös suoraan MUI:sta käytettyjä Buttoneita):
     * - sama korkeus, kirjainkoko ja pyöristys kaikissa ko'oissa
     * - lauseen alkukirjain isolla, ei VERSAALEJA (luettavampi pitkille suomenkielisille verbeille)
     * - contained: tumma vihreä, jotta valkoinen teksti täyttää WCAG AA -kontrastin (≈5:1)
     * - disabled näyttää disabloidulta (harmaa), ei aktiiviselta
     */
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          fontFamily: 'CircularBold',
          fontSize: '0.9375rem',
          lineHeight: 1.25,
          textTransform: 'none' as const,
          borderRadius: '8px',
          minHeight: '44px',
          padding: '10px 20px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          },
          '&.Mui-disabled': {
            backgroundColor: '#e3e6e3',
            color: '#7a817a',
            borderColor: '#e3e6e3'
          }
        },
        sizeSmall: {
          minHeight: '36px',
          padding: '6px 14px',
          fontSize: '0.875rem'
        },
        sizeMedium: {
          minHeight: '44px',
          padding: '10px 20px'
        },
        sizeLarge: {
          minHeight: '52px',
          padding: '14px 28px',
          fontSize: '1rem'
        },
        contained: {
          backgroundColor: '#3f7c36',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#2f6a28'
          },
          '&.Mui-disabled': {
            backgroundColor: '#e3e6e3',
            color: '#7a817a'
          }
        },
        containedPrimary: {
          backgroundColor: '#3f7c36',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#2f6a28'
          }
        },
        outlined: {
          backgroundColor: '#ffffff',
          color: '#141414',
          border: '1px solid #c4c4c4',
          '&:hover': {
            backgroundColor: '#f5f5f5',
            border: '1px solid #9a9a9a'
          },
          '&.Mui-disabled': {
            backgroundColor: '#ffffff',
            color: '#9a9a9a',
            border: '1px solid #e3e6e3'
          }
        },
        outlinedPrimary: {
          color: '#141414',
          border: '1px solid #c4c4c4',
          '&:hover': {
            border: '1px solid #9a9a9a'
          }
        },
        text: {
          color: '#3f7c36',
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
            color: '#9a9a9a'
          }
        }
      },
      variants: [
        {
          props: { variant: 'dashed' as any },
          style: {
            backgroundColor: '#ffffff',
            color: '#3f7c36',
            border: '1px dashed #3f7c36',
            '&:hover': {
              backgroundColor: '#f5f9f4',
              border: '1px dashed #3f7c36'
            }
          }
        }
      ]
    },
    MuiDatePickerToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: '#4f9b44',
          color: '#fff',
          padding: '16px 24px'
        },
        title: {
          color: '#fff',
          fontFamily: 'CircularBold',
          fontSize: '1.5rem',
          lineHeight: 1.2
        }
      }
    },
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: '#4f9b44',
          color: '#fff',
          '& .MuiTypography-root': {
            color: '#fff'
          }
        },
        content: {
          color: '#fff'
        },
        penIconButton: {
          display: 'none'
        },
        penIconButtonLandscape: {
          display: 'none'
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          marginTop: 8,
          marginBottom: 4,
          paddingLeft: 16,
          paddingRight: 16
        },
        labelContainer: {
          flex: 1,
          justifyContent: 'center',
          marginRight: 0
        },
        label: {
          color: '#000',
          fontWeight: 600
        },
        switchViewButton: {
          color: '#000'
        }
      }
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          color: '#000'
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          width: 36,
          height: 36,
          fontSize: '0.875rem',
          '&.MuiPickersDay-today:not(.Mui-selected)': {
            border: 'none'
          },
          '&.Mui-selected': {
            backgroundColor: '#4f9b44',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#3f7c36'
            }
          }
        },
        dayWithMargin: {
          margin: '0 2px'
        },
        today: {
          border: '1px solid rgb(221, 221, 221)'
        }
      }
    }
    // MuiButtonBase: {
    //   root: {
    //     fontFamily: 'CircularRegular'
    //   }
    // },
    // MuiGrid: {
    //   root: {
    //     fontFamily: 'CircularRegular'
    //   }
    // }
  }) as any
}

export { theme }
